import React from 'react'
import { Customer } from '../models/shared/Customer'
import CustomerName from './CustomerName';
import CustomerContact from './CustomerContact';
import { useText } from '../context/TextContext';
import Gravatar from './Gravatar';

interface Props {
    customer: Customer | null;
    noCustomerText?: boolean
    noIdentifier?: boolean;
}

export default function CustomerCard(props: Props) {
    const text = useText();
    const { customer } = props;

    // Calculate a deterministic background image index (1-3) based on customerId
    const customerBGIx = customer?.id
        ? (customer.id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % 3) + 1
        : 1;
    return (
        <div className="offer-profile">
            <div className='position-relative '>
                <img className='bg' src={`/assets/profile-buyer-bg${customerBGIx}.jpg`} alt="" />
                <Gravatar identifier={customer?.email || customer?.id} size='sm' className='profile-logo' />
            </div>
            <div className='details p-3'>
                <strong>{text.customer}</strong>

                {customer ? (
                    <>
                        <CustomerName customer={customer} />
                        <CustomerContact customer={customer} noIdentifier={props.noIdentifier} />
                    </>
                ) : (
                    props.noCustomerText ? (
                        <div className="text-muted">{text.noCustomer}</div>
                    ) : null
                )}
            </div>
        </div>
    )
}
